import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TreeNode } from 'primeng/api';
import { AnyInputConfig } from './dynamic-field.model';

@Component({
  selector: 'app-dynamic-field',
  templateUrl: './dynamic-field.component.html',
  styleUrls: ['./dynamic-field.component.scss'],
  standalone: false,
})
export class DynamicFieldComponent {
  @Input() config!: AnyInputConfig;
  @Input() group!: FormGroup;
  @Input() controlName!: string;

  @Output() searchClicked = new EventEmitter<void>();
  @Output() completeMethod = new EventEmitter<any>();
  @Output() selectSuggestion = new EventEmitter<any>();
  @Output() clearEvent = new EventEmitter<any>();
  @Output() nodeSelect = new EventEmitter<any>();
  @Output() nodeUnselect = new EventEmitter<any>();

  selectedFiles: TreeNode[] | TreeNode | null = null;

  trackByOption(index: number, option: any): any {
    return option.value;
  }

  onCompleteMethod(event: any) {
    this.completeMethod.emit(event);
  }

  onSelectOfSuggestion(event: any) {
    this.selectSuggestion.emit(event);
  }

  onClearEvent(event: any) {
    this.clearEvent.emit(event);
  }

  onSelectedTreeNode(event: any) {
    this.nodeSelect.emit(event);
  }
}
